"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PINDailyPeriodsSelector = void 0;
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var _DayPeriod_1 = require("./_DayPeriod");
var _TimeStringUtils_1 = require("./_TimeStringUtils");
var _PINDailyPeriod_1 = require("./_PINDailyPeriod");
function PINDailyPeriodsSelector(_a) {
    var periods = _a.periods, style = _a.style, dayStartTime = _a.dayStartTime, dayEndTime = _a.dayEndTime, periodDurationIncrement = _a.periodDurationIncrement, minPeriodDuration = _a.minPeriodDuration, onChange = _a.onChange, hideBoundaries = _a.hideBoundaries;
    var wrapperDiv = react_1.useRef(null);
    var _b = react_1.useState(0), wrapperHeight = _b[0], setWrapperHeight = _b[1];
    var _c = react_1.useState(false), isDragging = _c[0], setIsDragging = _c[1];
    var sortedPeriods = periods.sort(_DayPeriod_1.sortPeriods);
    var dayStartMinute = _TimeStringUtils_1.timeStringToMinutes(dayStartTime);
    var dayEndMinute = _TimeStringUtils_1.timeStringToMinutes(dayEndTime);
    var pxPerMinute = wrapperHeight / (dayEndMinute - dayStartMinute);
    var minPeriodDurationUsed = Math.max(
    // Based on component height (min. 26px)
    Math.ceil(26 / pxPerMinute / periodDurationIncrement) * periodDurationIncrement, 
    // Defined by props
    minPeriodDuration);
    /* Ensure update when ref is ready */
    react_1.useEffect(function () {
        var _a, _b;
        setWrapperHeight((_b = (_a = wrapperDiv.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height) !== null && _b !== void 0 ? _b : 0);
    }, []);
    var onPeriodChange = react_1.useCallback(function (index, updatedPeriod) {
        if (!onChange) {
            return;
        }
        onChange(sortedPeriods
            .map(function (period, i) { return (i === index ? updatedPeriod : period); })
            .filter(function (period) { return period != null; }));
    }, [onChange, sortedPeriods]);
    var createPeriod = react_1.useCallback(function (e) {
        if (!onChange) {
            return;
        }
        if (e.target instanceof HTMLDivElement && e.target.className.includes("day-periods")) {
            var clickOffsetY = e.clientY - e.target.getBoundingClientRect().top;
            var clickMinute = ((dayEndMinute - dayStartMinute) / wrapperHeight * clickOffsetY) + dayStartMinute;
            var usedMinute = clickMinute - (clickMinute % periodDurationIncrement);
            var usedTime_1 = _TimeStringUtils_1.minutesToTimeString(usedMinute);
            var endTime = _TimeStringUtils_1.minutesToTimeString(usedMinute + minPeriodDurationUsed);
            var nextEventIndex = sortedPeriods
                .findIndex(function (period) { return period.startAt.localeCompare(usedTime_1) > 0; });
            var previousEvent = nextEventIndex > 0
                ? sortedPeriods[nextEventIndex - 1]
                // Represent the start of the day
                : { startAt: "", endAt: _TimeStringUtils_1.minutesToTimeString(dayStartMinute) };
            var nextEvent = nextEventIndex >= 0
                ? sortedPeriods[nextEventIndex]
                // Represent the end of the day
                : { startAt: _TimeStringUtils_1.minutesToTimeString(dayEndMinute), endAt: "" };
            var endAt = !nextEvent || endTime.localeCompare(nextEvent.startAt) < 0
                ? endTime
                : nextEvent.startAt;
            /* If event is not long enough, try to bring it up to fit minimum duration */
            var endAtMinute = _TimeStringUtils_1.timeStringToMinutes(endAt);
            var currentDuration = endAtMinute - usedMinute;
            if (currentDuration < minPeriodDurationUsed) {
                usedMinute += currentDuration - minPeriodDurationUsed;
                usedTime_1 = _TimeStringUtils_1.minutesToTimeString(usedMinute);
            }
            /* Cannot start during or before the previous event */
            if (usedTime_1.localeCompare(previousEvent.endAt) < 0) {
                return;
            }
            onChange(__spreadArrays(sortedPeriods, [
                { startAt: usedTime_1, endAt: endAt }
            ]).sort(_DayPeriod_1.sortPeriods));
        }
    }, [
        dayEndMinute,
        dayStartMinute,
        sortedPeriods,
        onChange,
        wrapperHeight,
        minPeriodDurationUsed,
        periodDurationIncrement
    ]);
    return (react_1.default.createElement("div", { className: "pin-daily-periods-selector " + (isDragging ? "dragging" : ""), style: style },
        hideBoundaries !== true && (react_1.default.createElement("div", { className: "day-boundaries-marks" },
            react_1.default.createElement("span", { className: "day-start-mark" }, dayStartTime.replace(":", "h")),
            react_1.default.createElement("span", { className: "day-end-mark" }, dayEndTime.replace(":", "h")))),
        react_1.default.createElement("div", { className: "day-periods", onClick: createPeriod, ref: wrapperDiv }, periods === null || periods === void 0 ? void 0 : periods.map(function (_, index) { return (react_1.default.createElement(_PINDailyPeriod_1._PINDailyPeriod, { key: index, periods: sortedPeriods, index: index, dayStartTime: dayStartTime, dayEndTime: dayEndTime, onChange: onPeriodChange, wrapperHeight: wrapperHeight, minPeriodDurationUsed: minPeriodDurationUsed, onDragStateChange: setIsDragging, periodDurationIncrement: periodDurationIncrement })); }))));
}
exports.PINDailyPeriodsSelector = PINDailyPeriodsSelector;
PINDailyPeriodsSelector.propTypes = {
    /** The standard CSS style property. */
    style: prop_types_1.default.object,
    /**
     * An array of day periods (`{ startAt: string, endAt: string }`) using the "HH:mm" format for
     * both `startAt` and `endAt` fields.
     */
    periods: prop_types_1.default.arrayOf(_DayPeriod_1.DayPeriodPropType.isRequired).isRequired,
    /** The first time displayed on the column representing the day. */
    dayStartTime: prop_types_1.default.string.isRequired,
    /** The last time displayed on the column representing the day. */
    dayEndTime: prop_types_1.default.string.isRequired,
    /** The number of minutes used for incrementing or decrementing a time when updating periods. */
    periodDurationIncrement: prop_types_1.default.number.isRequired,
    /** The minimum number of minutes a period's duration should be. */
    minPeriodDuration: prop_types_1.default.number.isRequired,
    /** Called with the new array of periods when a change occurs. */
    onChange: prop_types_1.default.func,
    /** Hide the boundary marks displayed on top and bottom of the day column. */
    hideBoundaries: prop_types_1.default.bool,
};
PINDailyPeriodsSelector.defaultProps = {
    periods: [],
    dayStartTime: "06:00",
    dayEndTime: "21:00",
    periodDurationIncrement: 5,
    minPeriodDuration: 5,
    hideBoundaries: false,
};
//# sourceMappingURL=PINDailyPeriodsSelector.js.map